import styles from './ui.module.css';

/**
 * Класс выбранной вкладки таббара.
 *
 * Отдаётся наружу именем, а не компонентом: сам TabbarItem остаётся вкуишным
 * (он держит safe-area снизу, размер зоны нажатия и индикатор), а нам нужна
 * ровно одна добавка — светящаяся черта над выбранной вкладкой. В макетах это
 * главный признак «вы здесь», подсветка подписи там вторична.
 *
 * Стили модуля наружу отдаются только так: импортировать ui.module.css из
 * экрана нельзя, иначе граница слоя перестанет что-либо значить.
 */
export const TABBAR_ITEM_ACTIVE: string = styles.tabbarItemActive;
